module.exports = __webpack_public_path__ + "static/assets/7a7df71f41eb4a7b993eab7ab416db6e.png";